var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaginaInicial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home-icon-silhouette_1_",
    "data-name": "home-icon-silhouette (1)",
    transform: "translate(0 -17.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3043",
    "data-name": "Grupo 3043",
    transform: "translate(0.001 17.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3042",
    "data-name": "Grupo 3042",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2215",
    "data-name": "Caminho 2215",
    d: "M24.581,28.673l-3.789-4.187V19.649a1.44,1.44,0,1,0-2.866,0v1.67L15.1,18.2a3.516,3.516,0,0,0-5.211,0L.42,28.673a1.7,1.7,0,0,0,0,2.24,1.339,1.339,0,0,0,2.027,0L11.92,20.443a.788.788,0,0,1,1.159,0l9.474,10.47a1.34,1.34,0,0,0,2.027,0A1.7,1.7,0,0,0,24.581,28.673Z",
    transform: "translate(-0.001 -17.047)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2216",
    "data-name": "Caminho 2216",
    d: "M77.777,127.976a.614.614,0,0,0-.955,0l-8,9.206a.843.843,0,0,0-.2.551v6.715A2.686,2.686,0,0,0,71.1,147.3h3.959V140.24h4.47V147.3h3.959a2.686,2.686,0,0,0,2.478-2.853v-6.715a.84.84,0,0,0-.2-.551Z",
    transform: "translate(-64.8 -122.301)",
    fill: "#64c2c8"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginaInicial);
export default __webpack_public_path__ + "static/media/paginaInicial.31a6343afdbec66194e89dff80733e5d.svg";
export { ForwardRef as ReactComponent };